const organization = {
    require_membership: 'Użytkownik musi być członkiem organizacji, aby kontynuować.',
    role_names_not_found: '检测到无效的角色名称：{{names,list(type:conjunction)}}。请先创建这些角色，然后再继续。',
};
export default Object.freeze(organization);
